<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019-2023 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';
    import { iconList } from '@oat-sa-private/ui-identity';

    const fallbackIcon = iconList['rectangle-16'];

    export let ariaHidden = false;
    export let name = '';
    export let rtlFlip = false;
    $: icon = iconList[name] || fallbackIcon;
    let sizeClass;

    // Icon name may change on-the-fly based on media queries, so class should be reactive too
    $: if (icon) {
        if (icon.size === '12') {
            sizeClass = 'small';
        } else if (icon.size === '16') {
            sizeClass = 'medium';
        } else if (icon.size === '24') {
            sizeClass = 'large';
        }
    }
</script>

<style>
    @add-mixin dir-style .icon, --dir-rtl-multiplier, 1, -1;

    .icon {
        pointer-events: none;

        &,
        &.medium {
            min-width: 2rem;
            height: 2rem;
        }
        &.small {
            min-width: 1.5rem;
            height: 1.5rem;
        }
        &.large {
            min-width: 3rem;
            height: 3rem;
        }
        &.rtl-flip {
            transform: scaleX(var(--dir-rtl-multiplier));
        }
    }
</style>

<svg
    class="icon {sizeClass}"
    class:rtl-flip={rtlFlip}
    viewBox="0 0 {icon.size} {icon.size}"
    aria-hidden={ariaHidden}
    {...icon.attrs}>
    <title>{__(icon.title) || name}</title>
    {#each icon.paths as path}
        <path {...path} />
    {/each}
</svg>
